// ── Prescription (Schedule H / H1) detection ──────────────────────────────────
// India's Drugs & Cosmetics Act requires a valid prescription + a licensed
// pharmacy to dispense Schedule-H medicines. We flag catalogue items whose
// name/tags/description contain well-known prescription molecules so the shop
// and checkout can gate them. Kept deliberately conservative (clear Rx
// molecules only) to avoid flagging OTC cosmetics like plain salicylic-acid or
// benzoyl-peroxide washes.
// Per-country prescription schedules. Which molecules are "prescription-only"
// differs by country (a drug OTC in one place is Rx in another), so this is
// keyed by country code. India (Schedule H/H1) is the default today.
const SCHEDULES = {
  IN: [
    // Retinoids
    'tretinoin', 'isotretinoin', 'adapalene', 'tazarotene',
    // Antibiotics (topical + oral)
    'clindamycin', 'doxycycline', 'minocycline', 'azithromycin', 'erythromycin',
    'nadifloxacin', 'mupirocin', 'fusidic', 'dapsone', 'metronidazole',
    // Hair (Rx) — finasteride catches the minoxidil+finasteride combos
    'finasteride', 'dutasteride', 'spironolactone',
    // Pigmentation / immunomodulators
    'hydroquinone', 'tacrolimus', 'pimecrolimus',
    // Potent topical steroids
    'clobetasol', 'betamethasone', 'mometasone', 'halobetasol', 'fluticasone',
    'desonide', 'triamcinolone',
    // Antifungals (Rx in India)
    'ketoconazole', 'itraconazole', 'fluconazole', 'terbinafine', 'griseofulvin',
  ],
  // GB / US schedules can be added here when those markets open.
}
const DEFAULT_SCHEDULE = 'IN'

export const RX_LABEL = '℞ Prescription'

function _hay(product) {
  return ((product.name || '') + ' ' + ((product.tags || []).join ? (product.tags || []).join(' ') : product.tags || '') + ' ' + (product.desc || '')).toLowerCase()
}

export function isRx(product, country = DEFAULT_SCHEDULE) {
  if (!product) return false
  // An explicit backend flag always wins if present
  if (product.rx === 1 || product.rx === true || product.prescriptionRequired) return true
  const terms = SCHEDULES[country] || SCHEDULES[DEFAULT_SCHEDULE]
  const hay = _hay(product)
  return terms.some(t => hay.includes(t))
}

// The prescription molecule(s) a product contains
export function rxMoleculesIn(product, country = DEFAULT_SCHEDULE) {
  if (!product) return []
  const terms = SCHEDULES[country] || SCHEDULES[DEFAULT_SCHEDULE]
  const hay = _hay(product)
  return terms.filter(t => hay.includes(t))
}

// Does a prescription's text cover this product (same molecule)?
export function prescriptionCovers(product, rxText, country = DEFAULT_SCHEDULE) {
  const mols = rxMoleculesIn(product, country)
  if (!mols.length) return false
  const t = String(rxText || '').toLowerCase()
  return mols.some(m => t.includes(m))
}
